"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Procedure = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_Age_1 = require("./RTTI_Age");
var RTTI_Range_1 = require("./RTTI_Range");
var RTTI_Procedure_Performer_1 = require("./RTTI_Procedure_Performer");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var RTTI_Procedure_FocalDevice_1 = require("./RTTI_Procedure_FocalDevice");
exports.RTTI_Procedure = t.recursion('IProcedure', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('Procedure'),
            subject: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            instantiatesCanonical: t.array(RTTI_canonical_1.RTTI_canonical),
            instantiatesUri: t.array(RTTI_uri_1.RTTI_uri),
            _instantiatesUri: t.array(RTTI_Element_1.RTTI_Element),
            basedOn: t.array(RTTI_Reference_1.RTTI_Reference),
            partOf: t.array(RTTI_Reference_1.RTTI_Reference),
            status: RTTI_code_1.RTTI_code,
            _status: RTTI_Element_1.RTTI_Element,
            statusReason: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            category: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            code: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            encounter: RTTI_Reference_1.RTTI_Reference,
            performedDateTime: t.string,
            _performedDateTime: RTTI_Element_1.RTTI_Element,
            performedPeriod: RTTI_Period_1.RTTI_Period,
            performedString: t.string,
            _performedString: RTTI_Element_1.RTTI_Element,
            performedAge: RTTI_Age_1.RTTI_Age,
            performedRange: RTTI_Range_1.RTTI_Range,
            recorder: RTTI_Reference_1.RTTI_Reference,
            asserter: RTTI_Reference_1.RTTI_Reference,
            performer: t.array(RTTI_Procedure_Performer_1.RTTI_Procedure_Performer),
            location: RTTI_Reference_1.RTTI_Reference,
            reasonCode: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            reasonReference: t.array(RTTI_Reference_1.RTTI_Reference),
            bodySite: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            outcome: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            report: t.array(RTTI_Reference_1.RTTI_Reference),
            complication: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            complicationDetail: t.array(RTTI_Reference_1.RTTI_Reference),
            followUp: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            note: t.array(RTTI_Annotation_1.RTTI_Annotation),
            focalDevice: t.array(RTTI_Procedure_FocalDevice_1.RTTI_Procedure_FocalDevice),
            usedReference: t.array(RTTI_Reference_1.RTTI_Reference),
            usedCode: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept)
        })
    ]);
});
//# sourceMappingURL=RTTI_Procedure.js.map